(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DDShareCartCore = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MAX_URL_LENGTH = 7500;
  var ALLOWED_HOSTS = ['ddnailsupply.com', 'www.ddnailsupply.com'];

  class ShareCartError extends Error {
    constructor(code, message) {
      super(message);
      this.name = 'ShareCartError';
      this.code = code;
    }
  }

  function fail(code, message) {
    throw new ShareCartError(code, message);
  }

  function isRecord(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function hasData(value) {
    if (value === undefined || value === null || value === '') return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return true;
  }

  function verifiedOrigin(origin) {
    var parsed;
    if (typeof origin !== 'string') {
      fail('INVALID_ORIGIN', 'The share link must use the DDNailSupply storefront.');
    }
    try {
      parsed = new URL(origin);
    } catch (error) {
      fail('INVALID_ORIGIN', 'The share link must use the DDNailSupply storefront.');
    }
    if (parsed.protocol !== 'https:' || ALLOWED_HOSTS.indexOf(parsed.hostname) === -1 ||
        parsed.port || parsed.username || parsed.password || parsed.pathname !== '/' ||
        parsed.search || parsed.hash) {
      fail('INVALID_ORIGIN', 'The share link must use the DDNailSupply storefront.');
    }
    return parsed.origin;
  }

  function verifiedRoot(root) {
    if (typeof root !== 'string' ||
        !/^\/(?:[a-z]{2,3}(?:-[a-z]{4})?(?:-(?:[a-z]{2}|[0-9]{3}))?\/)?$/i.test(root)) {
      fail('INVALID_ROOT', 'The storefront language path is invalid.');
    }
    return root;
  }

  function variantId(value) {
    if (typeof value === 'number') {
      if (!Number.isSafeInteger(value) || value <= 0) {
        fail('INVALID_VARIANT', 'A cart item has an invalid variant.');
      }
      return String(value);
    }
    if (typeof value === 'string' && /^[1-9][0-9]*$/.test(value)) return value;
    fail('INVALID_VARIANT', 'A cart item has an invalid variant.');
  }

  function build(cart, options) {
    options = options || {};
    var origin = verifiedOrigin(options.origin);
    var root = verifiedRoot(options.root === undefined ? '/' : options.root);
    if (!isRecord(cart) || !Array.isArray(cart.items)) {
      fail('INVALID_CART', 'The cart could not be read. Please refresh and try again.');
    }
    if (cart.items.length === 0) fail('EMPTY_CART', 'Add an item before sharing your cart.');

    var quantities = new Map();
    var totalQuantity = 0;
    cart.items.forEach(function (item) {
      if (!isRecord(item)) fail('INVALID_CART', 'A cart item could not be read.');
      if (item.available === false) {
        fail('UNAVAILABLE_ITEM', 'Remove unavailable items before sharing your cart.');
      }
      if (hasData(item.properties)) {
        fail('UNSUPPORTED_PROPERTIES', 'This cart has item customizations that cannot be shared by link.');
      }
      if (hasData(item.selling_plan) || hasData(item.selling_plan_allocation)) {
        fail('UNSUPPORTED_SELLING_PLAN', 'This cart has a subscription or purchase plan that cannot be shared by link.');
      }
      if (hasData(item.item_components) || hasData(item.components) || hasData(item.parent_relationship)) {
        fail('UNSUPPORTED_BUNDLE', 'This cart has a bundle relationship that cannot be shared by link.');
      }

      var id = variantId(item.variant_id);
      var quantity = item.quantity;
      if (typeof quantity !== 'number' || !Number.isSafeInteger(quantity) || quantity <= 0) {
        fail('INVALID_QUANTITY', 'A cart item has an invalid quantity.');
      }
      var combined = (quantities.get(id) || 0) + quantity;
      var nextTotal = totalQuantity + quantity;
      if (!Number.isSafeInteger(combined) || !Number.isSafeInteger(nextTotal)) {
        fail('QUANTITY_OVERFLOW', 'This cart has too many items to share by link.');
      }
      quantities.set(id, combined);
      totalQuantity = nextTotal;
    });

    var entries = [];
    quantities.forEach(function (quantity, id) {
      entries.push({ variantId: id, quantity: quantity });
    });
    var url = origin + root + 'cart/' + entries.map(function (entry) {
      return entry.variantId + ':' + entry.quantity;
    }).join(',') + '?storefront=true';
    if (url.length > MAX_URL_LENGTH) {
      fail('URL_TOO_LONG', 'This cart has too many different items to share in one link.');
    }
    return { url: url, entries: entries, totalQuantity: totalQuantity };
  }

  return { build: build, ShareCartError: ShareCartError };
});
